(() => {
  const handle = 'naturalny-proszek-wybielajacy-aktywny-wegiel';
  const title = 'Proszek wybielający z węglem aktywnym •\u00a050\u00a0g';
  const contents = 'Zestaw: proszek, szczoteczka bambusowa i pudełko magnetyczne';
  const selector = `.qsc2-drawer a[href*="/products/${handle}"]`;
  let queued = false;

  function update() {
    queued = false;
    if (!/^pl(?:-|$)/i.test(document.documentElement.lang)) {
      document.querySelectorAll('.qsc2-drawer .lume-cart-short-title').forEach(link => {
        if (link.textContent === title) link.textContent = link.dataset.lumeOriginalTitle;
        if (link.nextElementSibling?.classList.contains('lume-cart-set-contents')) {
          link.nextElementSibling.remove();
        }
        link.classList.remove('lume-cart-short-title');
        delete link.dataset.lumeOriginalTitle;
      });
      return;
    }
    document.querySelectorAll(selector).forEach(link => {
      const url = new URL(link.href, location.href);
      if (url.pathname.split('/').filter(Boolean).at(-1) !== handle) return;
      if (link.querySelector('img') || !link.textContent.trim()) return;
      if (!link.classList.contains('lume-cart-short-title')) {
        link.dataset.lumeOriginalTitle = link.textContent;
        link.classList.add('lume-cart-short-title');
      }
      if (link.textContent !== title) link.textContent = title;
      let detail = link.nextElementSibling;
      if (!detail?.classList.contains('lume-cart-set-contents')) {
        detail = document.createElement('span');
        detail.className = 'lume-cart-set-contents';
        link.after(detail);
      }
      if (detail.textContent !== contents) detail.textContent = contents;
    });
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  }

  const observer = new MutationObserver(records => {
    if (records.some(record => {
      const element = record.target.nodeType === Node.ELEMENT_NODE
        ? record.target : record.target.parentElement;
      return element?.closest('.qsc2-drawer') || Array.from(record.addedNodes).some(node =>
        node.nodeType === Node.ELEMENT_NODE &&
        (node.matches('.qsc2-drawer') || node.querySelector('.qsc2-drawer')));
    })) schedule();
  });
  observer.observe(document.body, {childList: true, subtree: true, characterData: true});
  new MutationObserver(schedule).observe(document.documentElement, {attributes: true, attributeFilter: ['lang']});
  update();
})();
